import { Fragment, useEffect, useState } from "react";
import classes from "../hpschedulingdetails/HpSchedulingDetails.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import Progress from "../../progressbar/RegistrationProgressBar";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import HpScheduleTimings from "./HpScheduleTimings";
import HpSchedulingDetailsTable from "./HpSchedulingDetailsTable";
import { getRequest } from "../../../../api/AxiosAPICall";
import { Grid, MenuItem, Typography, Backdrop } from "@mui/material";
import { FormikProvider } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { nanoid } from "nanoid";

const HpSchedulingDetails = ({
  formik,
  hpSchedulingData,
}: {
  formik: any;
  hpSchedulingData: any;
}) => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [userData, setUserData] = useState([]) as any;
  const [userIdForEdit, setUserIdForEdit] = useState();
  const [defaultFarAll, setDefaultFarAll] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [clinicTypes, setClinicTypes] = useState([]);
  const [clinicTypeLocation, setClinicTypeLocation] = useState([]);
  const [resetField, setResetField] = useState(false);
  const dispatch = useDispatch();
  const { userJson } = useSelector((state: any) => state.user);

  useEffect(() => {
    if (Object.values(userData)?.length === 0) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
    // eslint-disable-next-line
  }, [Object.values(userData)?.length]);

  const setTouchForAll = async () => {
    formik.setFieldTouched("userName");
    formik.setFieldTouched("clinicType");
    formik.setFieldTouched("clinicLocation");
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    await days.forEach((element: any) => {
      formik?.values[element].forEach((weekField: any, index: any) => {
        formik.setFieldTouched(`${element}[${index}].numberOfAppointment`);
        formik.setFieldTouched(`${element}[${index}].duration`);
        formik.setFieldTouched(`${element}[${index}].startTime`);
        formik.setFieldTouched(`${element}[${index}].endTime`);
        weekField.startTime === "" &&
          formik.setFieldValue(`${element}[${index}].startTime`, null);
        weekField.endTime === "" &&
          formik.setFieldValue(`${element}[${index}].endTime`, null);
      });
    });
  };

  const setUntouchForAll = () => {
    formik.setFieldTouched("userName", false);
    formik.setFieldTouched("clinicType", false);
    formik.setFieldTouched("clinicLocation", false);
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.forEach((element: any) => {
      formik?.values[element]?.forEach((_weekField: any, index: any) => {
        formik.setFieldTouched(
          `${element}[${index}].numberOfAppointment`,
          false
        );
        formik.setFieldTouched(`${element}[${index}].duration`, false);
        formik.setFieldTouched(`${element}[${index}].startTime`, false);
        formik.setFieldTouched(`${element}[${index}].endTime`, false);
      });
    });
  };

  const ResetAllField = (formik: any) => {
    formik.setFieldValue("userName", "");
    formik.setFieldValue("clinicType", "");
    formik.setFieldValue("clinicLocation", "");
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.forEach((element: any) => {
      formik?.values[element]?.forEach((weekField: any, index: any) => {
        formik.setFieldValue(`${element}[${index}].isLeave`, false);
        formik.setFieldValue(`${element}[${index}].numberOfAppointment`, "");
        formik.setFieldValue(`${element}[${index}].duration`, "");
        formik.setFieldValue(`${element}[${index}].startTime`, null);
        formik.setFieldValue(`${element}[${index}].endTime`, null);
        formik.setFieldValue(`${element}[${index}].setAsDefault`, false);
      });
    });

    if (Object.keys(formik.errors).length !== 0) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please enter all required fields.",
          "top",
          "center"
        )
      );
    }
  };

  const SetHpSheduleForAll = async (formik: any, value: any) => {
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    await days.forEach((element: string) => {
      console.log(value[element], " formik?.values[element]");
      value[element].forEach((_weekField: any, index: any) => {
        formik.setFieldValue(
          `${element}[${index}].isLeave`,
          value[element][index]?.isLeave
        );
        formik.setFieldValue(
          `${element}[${index}].clinicType`,
          value[element][index]?.clinicType
        );

        formik.setFieldValue(
          `${element}[${index}].clinicLocation`,
          value[element][index]?.clinicLocation
        );
        formik.setFieldValue(
          `${element}[${index}].numberOfAppointment`,
          value[element][index]?.numberOfAppointment
        );
        formik.setFieldValue(
          `${element}[${index}].duration`,
          value[element][index]?.duration
        );
        formik.setFieldValue(
          `${element}[${index}].startTime`,
          value[element][index]?.startTime
        );
        formik.setFieldValue(
          `${element}[${index}].endTime`,
          value[element][index]?.endTime
        );

        formik.setFieldValue(
          `${element}[${index}].setAsDefault`,
          value[element][index]?.setAsDefault
        );
      });
    });
    console.log("awite");
  };

  const handleEdit = async (data: any, index: any) => {
    setUserIdForEdit(data.userId);
    window.scrollTo(0, 0);
    setIsUpdate(true);
    formik.setFieldValue("userName", data.userName);
    formik.setFieldValue("clinicType", data.clinicType);
    formik.setFieldValue("clinicLocation", data.clinicLocation);
    SetHpSheduleForAll(formik, data);
  };

  const handleUpdate = (data: any, formik: any) => {
    const index = data.findIndex((object: any) => {
      return object.userId === userIdForEdit;
    });

    if (index !== -1) {
      data[index].userId = userIdForEdit;
      data[index].userName = formik.userName;
      data[index].clinicType = formik.clinicType;
      data[index].clinicLocation = formik.clinicLocation;
      let monday: any[] = [];
      let tuesday: any[] = [];
      let wednesday: any[] = [];
      let thursday: any[] = [];
      let friday: any[] = [];
      let saturday: any[] = [];
      let sunday: any[] = [];

      formik?.monday?.forEach((weekField: any, index: any) => {
        monday.push({
          isLeave: formik.monday[index].isLeave,
          numberOfAppointment: formik.monday[index].numberOfAppointment,
          duration: formik.monday[index].duration,
          startTime: formik.monday[index].startTime,
          endTime: formik.monday[index].endTime,
          setAsDefault: formik.monday[index].setAsDefault,
        });
      });
      data[index].monday = monday;

      formik?.tuesday?.forEach((weekField: any, index: any) => {
        tuesday.push({
          isLeave: formik.tuesday[index].isLeave,
          numberOfAppointment: formik.tuesday[index].numberOfAppointment,
          duration: formik.tuesday[index].duration,
          startTime: formik.tuesday[index].startTime,
          endTime: formik.tuesday[index].endTime,
          setAsDefault: formik.tuesday[index].setAsDefault,
        });
      });

      data[index].tuesday = tuesday;

      formik?.wednesday?.forEach((weekField: any, index: any) => {
        wednesday.push({
          isLeave: formik.wednesday[index].isLeave,
          numberOfAppointment: formik.wednesday[index].numberOfAppointment,
          duration: formik.wednesday[index].duration,
          startTime: formik.wednesday[index].startTime,
          endTime: formik.wednesday[index].endTime,
          setAsDefault: formik.wednesday[index].setAsDefault,
        });
      });

      data[index].wednesday = wednesday;

      formik?.thursday?.forEach((weekField: any, index: any) => {
        thursday.push({
          isLeave: formik.thursday[index].isLeave,
          numberOfAppointment: formik.thursday[index].numberOfAppointment,
          duration: formik.thursday[index].duration,
          startTime: formik.thursday[index].startTime,
          endTime: formik.thursday[index].endTime,
          setAsDefault: formik.thursday[index].setAsDefault,
        });
      });

      data[index].thursday = thursday;

      formik?.friday?.forEach((weekField: any, index: any) => {
        friday.push({
          isLeave: formik.friday[index].isLeave,
          numberOfAppointment: formik.friday[index].numberOfAppointment,
          duration: formik.friday[index].duration,
          startTime: formik.friday[index].startTime,
          endTime: formik.friday[index].endTime,
          setAsDefault: formik.friday[index].setAsDefault,
        });
      });

      data[index].friday = friday;

      formik?.saturday?.forEach((weekField: any, index: any) => {
        saturday.push({
          isLeave: formik.saturday[index].isLeave,
          numberOfAppointment: formik.saturday[index].numberOfAppointment,
          duration: formik.saturday[index].duration,
          startTime: formik.saturday[index].startTime,
          endTime: formik.saturday[index].endTime,
          setAsDefault: formik.saturday[index].setAsDefault,
        });
      });

      data[index].saturday = saturday;

      formik?.sunday?.forEach((weekField: any, index: any) => {
        sunday.push({
          isLeave: formik.sunday[index].isLeave,
          numberOfAppointment: formik.sunday[index].numberOfAppointment,
          duration: formik.sunday[index].duration,
          startTime: formik.sunday[index].startTime,
          endTime: formik.sunday[index].endTime,
          setAsDefault: formik.sunday[index].setAsDefault,
        });
      });

      data[index].sunday = sunday;
    }
  };

  const handleDelete = (event: any, removeIndex: any) => {
    ResetAllField(formik);
    setUntouchForAll();
    setIsUpdate(false);
    setUserData((oldArray: any) => {
      return oldArray.filter((value: any, index: any) => index !== removeIndex);
    });

    dispatch(
      setSnackbar(
        true,
        2000,
        "success",
        "HP scheduled deleted sucessfully!",
        "top",
        "center"
      )
    );
  };

  const updateUserSchedule = () => {
    setTouchForAll();
    if (
      Object.keys(formik.errors).length !== 0 &&
      Object.keys(formik.touched).length === 0
    ) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please fill all required fields!",
          "top",
          "center"
        )
      );
      setIsUpdating(false);
    }
    const isIdFound = userData?.some((element: any) => {
      if (
        formik?.values?.userName === element?.userName &&
        formik?.values?.clinicType === element?.clinicType &&
        formik?.values?.clinicLocation === element?.clinicLocation &&
        userIdForEdit !== element?.userId
      ) {
        return true;
      }
      return false;
    });
    if (isIdFound) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cannot have two users with similar clinic type and clinic location.",
          "top",
          "center"
        )
      );
      setIsUpdating(false);
    }
    setTimeout(() => {
      if (
        formik.values.monday[0].setAsDefault === false &&
        formik.values.tuesday[0].setAsDefault === false &&
        formik.values.wednesday[0].setAsDefault === false &&
        formik.values.thursday[0].setAsDefault === false &&
        formik.values.friday[0].setAsDefault === false &&
        formik.values.saturday[0].setAsDefault === false &&
        formik.values.sunday[0].setAsDefault === false
      ) {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Please set at least one default record!",
            "top",
            "center"
          )
        );
        setIsUpdating(false);
      } else if (
        !isIdFound &&
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0
      ) {
        setIsUpdate(false);
        ResetAllField(formik);
        setResetField(true);
        handleUpdate(userData, formik.values);
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "HP scheduled updated sucessfully!",
            "top",
            "center"
          )
        );
        setUntouchForAll();
        setIsUpdating(false);
        setResetField(false);
      } else if (Object.keys(formik.errors).length !== 0) {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Please fill all required fields!",
            "top",
            "center"
          )
        );
        setIsUpdating(false);
      }
    }, 500);
  };

  const addUserSchedule = () => {
    console.log(formik.errors);
    if (
      Object.keys(formik.errors).length !== 0 &&
      Object.keys(formik.touched).length === 0
    ) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please fill all required fields!",
          "top",
          "center"
        )
      );
      setIsAdding(false);
    }

    setTimeout(() => {
      setTouchForAll();
      const isFound = userData?.some((element: any) => {
        if (
          formik?.values?.userName === element?.userName &&
          formik?.values?.clinicType === element?.clinicType &&
          formik?.values?.clinicLocation === element?.clinicLocation &&
          userIdForEdit !== element?.userId
        ) {
          return true;
        }
        return false;
      });

      if (isFound) {
        setDefaultFarAll(false);
        setIsAdding(false);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cannot have two users with similar clinic type and clinic location.",
            "top",
            "center"
          )
        );
      }

      if (
        formik.values.monday[0].setAsDefault === false &&
        formik.values.tuesday[0].setAsDefault === false &&
        formik.values.wednesday[0].setAsDefault === false &&
        formik.values.thursday[0].setAsDefault === false &&
        formik.values.friday[0].setAsDefault === false &&
        formik.values.saturday[0].setAsDefault === false &&
        formik.values.sunday[0].setAsDefault === false
      ) {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Please set at least one default record!",
            "top",
            "center"
          )
        );
        setIsAdding(false);
      } else if (
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0 &&
        !isFound &&
        formik.values.userName !== undefined &&
        formik.values.userName !== "" &&
        formik.values.userName !== null
      ) {
        userData.push(formik.values);
        ResetAllField(formik);
        formik.resetForm();
        formik.setFieldValue("userId", +formik?.values?.userId + 1);
        dispatch(
          setSnackbar(
            true,
            2000,
            "success",
            "Hp appointment schedule updated correctly.",
            "top",
            "center"
          )
        );
        setUntouchForAll();
        setIsAdding(false);
      } else if (Object.keys(formik.errors).length !== 0) {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Please fill all required fields!",
            "top",
            "center"
          )
        );
        setIsAdding(false);
      }
    }, 500);
  };

  useEffect(() => {
    formik.setFieldValue("clinicType", "");
    formik.setFieldValue("clinicLocation", "");
    //eslint-disable-next-line
  }, [formik.values.userName]);
  useEffect(() => {
    formik.setFieldValue("clinicLocation", "");
    //eslint-disable-next-line
  }, [formik.values.clinicType]);

  useEffect(() => {
    const fetchClinicTypes = async () => {
      const response = await getRequest("clinicTypes", {
        params: {
          username: formik.values.userName,
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setClinicTypes(response?.data);
      }
    };

    formik.values.userName && fetchClinicTypes();

    //eslint-disable-next-line
  }, [formik.values.userName]);

  useEffect(() => {
    const fetchClinicTypeLocations = async () => {
      const response = await getRequest("clinicTypeLocations", {
        params: {
          clinicTypeEliId: formik?.values?.clinicType?.split("@~@@").shift(),
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        console.log(response.data);
        setClinicTypeLocation(response?.data);
      }
    };

    formik?.values?.clinicType && fetchClinicTypeLocations();

    //eslint-disable-next-line
  }, [formik.values.clinicType]);

  return (
    <Fragment>
      <Progress activeStep={4} />
      <FormikProvider value={formik}>
        <CommonCard>
          <Grid
            container
            spacing={2}
            className={classes.rowSpace}
            direction="row"
            sx={{ marginBottom: "20px" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.formControlZeroMarginTop}
            >
              <SelectField
                id="userName"
                name="userName"
                headerText="Select Username"
                label="Select Username"
                value={formik.values.userName}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                isrequired={true}
                list={userJson?.map((user: any, index: number) => (
                  <MenuItem key={nanoid()} value={user}>
                    {user}
                  </MenuItem>
                ))}
                error={
                  formik.touched.userName && Boolean(formik.errors.userName)
                }
              />
              {formik.touched.userName && formik.errors.userName && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  {formik.errors.userName}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.formControlZeroMarginTop}
            >
              <SelectField
                id="clinicType"
                name="clinicType"
                headerText="Select Clinic Type"
                label="Select Clinic Type"
                value={formik.values.clinicType}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                isrequired={true}
                list={clinicTypes?.map((clinicType: any, index: number) => (
                  <MenuItem
                    key={nanoid()}
                    value={
                      clinicType.clinicTypeEliId +
                      "@~@@" +
                      clinicType.clinicTypeEliText
                    }
                  >
                    {" "}
                    {clinicType.clinicTypeEliText}
                  </MenuItem>
                ))}
                error={
                  formik.touched.clinicType && Boolean(formik.errors.clinicType)
                }
              />
              {formik.touched.clinicType && formik.errors.clinicType && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  {formik.errors.clinicType}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.formControlZeroMarginTop}
            >
              <SelectField
                id="clinicLocation"
                name="clinicLocation"
                headerText="Select Clinic Location"
                label="Select Clinic Location"
                value={formik.values.clinicLocation}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                isrequired={true}
                list={clinicTypeLocation.map((location: any, index: number) => (
                  <MenuItem
                    key={nanoid()}
                    value={
                      location.clinicLocationEliId +
                      "@~@@" +
                      location.clinicLocationEliText
                    }
                  >
                    {location.clinicLocationEliText}
                  </MenuItem>
                ))}
                error={
                  formik.touched.clinicLocation &&
                  Boolean(formik.errors.clinicLocation)
                }
              />
              {formik.touched.clinicLocation &&
                formik.errors.clinicLocation && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    {formik.errors.clinicLocation}
                  </Typography>
                )}
            </Grid>

            {/* Hp Scheduling page is started Here */}
            <Grid item xs={12} md={12}>
              <HpScheduleTimings formik={formik} resetField={resetField} />
            </Grid>
          </Grid>
        </CommonCard>

        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "15px",
          }}
        >
          {isUpdate ? (
            <ButtonComponent
              buttonclass={globalClasses.addAnotherServiceGreen}
              variant="contained"
              size="small"
              onClick={(event: any) => {
                setIsUpdating(true);

                updateUserSchedule();
                event.preventDefault();
              }}
              loader={true}
              label="Update"
            />
          ) : (
            <form>
              <ButtonComponent
                buttonclass={globalClasses.addAnotherServiceGreen}
                variant="contained"
                size="small"
                onClick={(event: any) => {
                  setIsAdding(true);
                  addUserSchedule();
                  event.preventDefault();
                }}
                label="Add Schedule"
              />
            </form>
          )}
        </Grid>
        <HpSchedulingDetailsTable
          getData={userData}
          setData={handleEdit}
          deleteUser={handleDelete}
        />
        <Grid container spacing={2} direction="row">
          <Grid item xs={12} md={12}>
            <form>
              <ButtonComponent
                variant="contained"
                size="small"
                type="submit"
                buttonclass={classes.registerUserButton}
                onClick={(event: any) => {
                  hpSchedulingData(userData);
                  event.preventDefault();
                }}
                disable={disableSubmit}
                label="Save"
              />
            </form>
          </Grid>
        </Grid>
      </FormikProvider>

      {(isAdding || isUpdating || defaultFarAll) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          {isAdding && (
            <Typography fontWeight="600" fontSize="20px">
              Adding Hp Scheduling information...!
            </Typography>
          )}
          {isUpdating && (
            <Typography fontWeight="600" fontSize="20px">
              Updating Hp Schedule...!
            </Typography>
          )}
          {defaultFarAll && (
            <Typography fontWeight="600" fontSize="20px">
              Setting default hp schedule timings...!
            </Typography>
          )}
        </Backdrop>
      )}
    </Fragment>
  );
};

export default HpSchedulingDetails;
